import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React from 'react';
import { View, Text, StyleSheet, Pressable } from 'react-native';
import { ButtonGroup } from '../../ButtonGroup/rn';
import Chat from '../../../assets/images/rn/Chat';
import Mail from '../../../assets/images/rn/mail';
import Phone from '../../../assets/images/rn/phone';
import { replaceParams } from '../../../utils/tools';
var ChannelOptionsButton = function ChannelOptionsButton(_ref) {
  var _ref$button_type = _ref.button_type,
    button_type = _ref$button_type === void 0 ? 'btn_live' : _ref$button_type,
    _ref$text_value = _ref.text_value,
    text_value = _ref$text_value === void 0 ? '' : _ref$text_value,
    _ref$extra_param = _ref.extra_param,
    desc = _ref$extra_param.desc,
    day = _ref$extra_param.day,
    _ref$disableButtons = _ref.disableButtons,
    disableButtons = _ref$disableButtons === void 0 ? false : _ref$disableButtons,
    onButtonsClick = _ref.onButtonsClick;
  var isBtnLive = button_type === 'btn_live';
  var descText = isBtnLive ? "".concat(desc) : "".concat(replaceParams(desc, {
    day: day
  }));
  return /*#__PURE__*/React.createElement(Pressable, {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      // for disabled
      opacity: disableButtons ? 0.5 : 1
    },
    onPress: function onPress() {
      if (disableButtons) {
        return;
      }
      onButtonsClick();
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      display: 'flex',
      padding: 5,
      alignItems: 'flex-start',
      borderRadius: 8,
      backgroundColor: isBtnLive ? '#FEF6F5' : '#F5F5F5',
      // backgroundColor: '#F5F5F5',
      marginRight: 6
    }
  }, isBtnLive && /*#__PURE__*/React.createElement(Chat, null), button_type === 'btn_submit_webform' && /*#__PURE__*/React.createElement(Mail, null), (button_type === 'btn_general_call' || button_type === 'btn_virtual_call') && /*#__PURE__*/React.createElement(Phone, null)), /*#__PURE__*/React.createElement(View, {
    style: {
      width: '100%',
      paddingRight: 44
    }
  }, /*#__PURE__*/React.createElement(Text, {
    style: {
      fontSize: 16,
      lineHeight: 20,
      color: isBtnLive ? '#EE4D2D' : 'rgba(0, 0, 0, 0.65)' // color: 'rgba(0, 0, 0, 0.65)',
    }
  }, text_value), /*#__PURE__*/React.createElement(Text, {
    style: {
      fontSize: 10,
      lineHeight: 12,
      marginTop: 2,
      color: 'rgba(0, 0, 0, 0.54)'
    }
  }, descText)));
};
export var ChannelOptionsMessage = function ChannelOptionsMessage(props) {
  var _props$styles = props.styles,
    styles = _props$styles === void 0 ? {
      containerStyle: {},
      textStyle: {}
    } : _props$styles,
    _props$messageContent = props.messageContent,
    messageContent = _props$messageContent === void 0 ? '' : _props$messageContent,
    buttons = props.buttons,
    _onButtonsClick = props.onButtonsClick,
    disableButtons = props.disableButtons,
    isChannelOptionsButton = props.isChannelOptionsButton;
  return /*#__PURE__*/React.createElement(View, {
    style: [Styles.message, styles === null || styles === void 0 ? void 0 : styles.containerStyle]
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      paddingVertical: 10,
      paddingHorizontal: 12
    }
  }, /*#__PURE__*/React.createElement(Text, {
    style: {
      color: 'rgba(0, 0, 0, 0.87)',
      fontSize: 16,
      lineHeight: 20
    }
  }, messageContent)), /*#__PURE__*/React.createElement(ButtonGroup, {
    buttons: isChannelOptionsButton ? buttons.map(function (button, index) {
      return {
        type: 'text',
        styles: {
          containerStyle: {
            textAlign: 'left',
            marginLeft: index === 0 ? 0 : 10,
            marginRight: index === 0 ? 0 : 10,
            paddingLeft: index === 0 ? 10 : 0
          }
        },
        children: /*#__PURE__*/React.createElement(ChannelOptionsButton, _extends({}, button, {
          disableButtons: disableButtons,
          onButtonsClick: function onButtonsClick() {
            _onButtonsClick(button);
          }
        }))
      };
    }) : buttons.map(function (button, index) {
      var _button$styles;
      return _objectSpread(_objectSpread({}, button), {}, {
        styles: {
          textStyle: _objectSpread(_objectSpread({}, button === null || button === void 0 ? void 0 : (_button$styles = button.styles) === null || _button$styles === void 0 ? void 0 : _button$styles.textStyle), {}, {
            opacity: disableButtons ? 0.5 : 1,
            fontSize: 16,
            lineHeight: 18
          }),
          containerStyle: {
            marginLeft: index === 0 ? 0 : 10,
            marginRight: index === 0 ? 0 : 2,
            paddingLeft: index === 0 ? 10 : 0
          }
        }
      });
    }),
    disabled: disableButtons
  }));
};
var Styles = StyleSheet.create({
  message: {
    maxWidth: '100%'
  }
});